import { Channels } from '../../components/common/channelsEnum';
import { SenderPOSTRequest } from '../backend/SenderPOSTRequest';

export enum NotificationDetailsStatus {
  RECEIVED = 'RECEIVED',
  SCHEDULED = 'SCHEDULED',
  BATCHING = 'BATCHING',
  BATCHED = 'BATCHED',
  IGNORED = 'IGNORED',
  FAILURE = 'FAILURE',
  SENDING = 'SENDING',
  SENT = 'SENT',
  COMPLAINT = 'COMPLAINT',
  DELIVERED = 'DELIVERED'
}

export enum NotificationStatus {
  RECEIVED = 'RECEIVED',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export interface NotificationSummaryLogMessage {
  trackingId: string;
  envId: string;
  status: NotificationStatus;
  request: SenderPOSTRequest;
  channelsObj: Partial<
    {
      [key in Channels]: boolean;
    }
  >;
  channels: Channels[];
  error?: Error;
}
